import { z } from 'zod'
import { oc } from '@orpc/contract'

/**
 * Given a batch of calendar appointments, returns the ids of those whose patient
 * is "Returning": i.e. has at least one Completed (`fulfilled`) appointment, or one
 * finished clinical Encounter (an ad-hoc "New Encounter" visit has no Appointment),
 * that started strictly before `before`. The caller supplies `before` as the start of
 * the appointment's calendar day (in the viewer's timezone) so the "earlier
 * calendar day" rule matches what is rendered on the calendar.
 */
export const getReturningPatientStatuses = oc
  .route({ method: 'POST', path: '/v2/appointments/returning-statuses' })
  .input(
    z.object({
      items: z.array(
        z.object({
          encounterId: z.string(),
          patientId: z.string(),
          before: z.string(),
        }),
      ),
    }),
  )
  .output(
    z.object({
      returningEncounterIds: z.array(z.string()),
    }),
  )
